// Application routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  BUSINESS_DETAIL: '/business/:businessId',
  BOOKING: '/book/:businessId',
  MY_BOOKINGS: '/my-bookings',
  DASHBOARD_SETTINGS: '/dashboard/settings',
  DASHBOARD_CALENDAR: '/dashboard/calendar',
  DASHBOARD_PROFILE: '/dashboard/profile',
  // Business owner configuration routes
  BUSINESS_SETTINGS: '/settings/business/:customerId',
  CALENDAR_CONFIG: '/settings/calendar/:customerId',
  VOICE_AGENT: '/voice-agent/:customerId',
  DEMO_CALL: '/demo/:customerId',
  // Business owner calendar management routes (new)
  CALENDAR_OVERVIEW: '/calendar/:customerId',
  CALENDAR_VIEW: '/calendar/:customerId/view',
};

export const getBusinessDetailPath = (businessId) => `/business/${businessId}`;
export const getBookingPath = (businessId) => `/book/${businessId}`;
export const getBusinessSettingsPath = (customerId) => `/settings/business/${customerId}`;
export const getCalendarConfigPath = (customerId) => `/settings/calendar/${customerId}`;
export const getVoiceAgentPath = (customerId) => `/voice-agent/${customerId}`;
export const getDemoCallPath = (customerId) => `/demo/${customerId}`;
export const getCalendarOverviewPath = (customerId) => `/calendar/${customerId}`;
export const getCalendarViewPath = (customerId) => `/calendar/${customerId}/view`;
